import {
  getLeoUuid,
  LeoUUID,
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { ProjectDetails, ProjectDetailsDTO } from "../types/projectDetails";
/* eslint-disable import/export */
export abstract class GetProjectDetailsRPC implements
  LeoRPC<GetProjectDetailsRPC.Request, GetProjectDetailsRPC.Response, GetProjectDetailsRPC.Errors.Errors>
{
  abstract execute(
    request: GetProjectDetailsRPC.Request
  ): Promise<LeoRPCResult<GetProjectDetailsRPC.Response, GetProjectDetailsRPC.Errors.Errors>>;
}

export namespace GetProjectDetailsRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    projectId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetProjectDetailsRPCRequest: boolean = true;
  
    readonly projectId: LeoUUID;
  
  
    constructor(
    projectId: LeoUUID
    ) {
      this.projectId = projectId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      return new Request(
        projectId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          projectId: this.projectId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetProjectDetailsRPC(projectId='${this.projectId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    projectDetails: ProjectDetailsDTO;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetProjectDetailsResponse: boolean = true;
  
    readonly projectDetails: ProjectDetails;
  
  
    constructor(
    projectDetails: ProjectDetails
    ) {
      this.projectDetails = projectDetails;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const projectDetails = ProjectDetails.fromDTO(getObject(dto, "projectDetails", InvalidResponseProjectDetailsError));
      return new Response(
        projectDetails
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          projectDetails: this.projectDetails.toDTO()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetProjectDetails(projectDetails='${this.projectDetails}')`;
  };
  

  export enum RPCError {
    InvalidProjectId = "INVALID_PROJECT_ID"
  }

  export namespace Errors {
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `GetProjectDetailsRPC.INVALID_PROJECT_ID()`;
    };
    

    export type Errors = InvalidProjectId;
    export type ErrorsDTO = InvalidProjectIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestProjectIdError extends GetProjectDetailsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidResponseProjectDetailsError extends GetProjectDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseProjectDetailsError";
  }
}

export class InvalidResponseInvalidProjectIdError extends GetProjectDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

